import { Routes } from "@angular/router";
import { gruposRoutes } from "./grupos/grupos.routes";
import GruposComponent from "./grupos/grupos.component";
import { tipoTransaccionRoutes } from "./tipo-transaccion/tipo-transaccion.routes";

export const configuracionRoutes: Routes = [
  {
    path: "config_inicio",
    loadComponent: () => import("./inicio/inicio-configuracion.component"),
    data: {
      codmod: "CEN",
      icon: "home",
    },
  },
  {
    path: "config_grupos",
    loadChildren: () =>
      import("./grupos/grupos.routes").then((m) => m.gruposRoutes),
    data: {
      codmod: "CEN",
      icon: "group_work",
    },
  },
  {
    path: "config_usuarios-reemplazo",
    loadChildren: () =>
      import("./usuarios-reemplazo/usuarios-reemplazo.routes").then(
        (m) => m.usuariosRRoutes
      ),
    data: {
      codmod: "CEN",
      icon: "person",
    },
  },
  {
    path: "config_usuarios-licencia",
    loadChildren: () =>
      import("./usuarios-licencia/usuarios-licencia.routes").then(
        (m) => m.usuariosLicRoutes
      ),
    data: {
      codmod: "CEN",
      icon: "badge",
    },
  },
  {
    path: "config_imputaciones-proveedores",
    loadComponent: () =>
      import(
        "./parametrizacion-imputaciones/parametrizacion-imputaciones.component"
      ),
    data: {
      codmod: "CEN",
      icon: "list_alt",
    },
  },
  {
    path: "config_permisos-provia",
    loadComponent: () =>
      import("./visualizacion-provia/visualizacion-provia.component").then(
        (m) => m.VisualizacionProviaComponent
      ),
    data: {
      codmod: "CEN",
      icon: "visibility",
    },
  },
  {
    path: "config_tipos-transacciones",
    loadChildren: () =>
      import("./tipo-transaccion/tipo-transaccion.routes").then(
        (m) => m.tipoTransaccionRoutes
      ),
    data: {
      codmod: "CEN",
      icon: "list_alt",
    },
  },
  {
    path: "config_clasificadores-cuenta",
    loadChildren: () =>
      import("./clasificadores-cuenta/clasificadores-cuenta.routes").then(
        (m) => m.ClasificadoresCuentaRoutes
      ),
    data: {
      codmod: "CEN",
      icon: "class",
    },
  },
  {
    path: "config_modificacion-imputaciones",
    loadComponent: () =>
      import(
        "./modificacion-imputaciones/modificacion-imputaciones.component"
      ).then((m) => m.ModificacionImputacionesComponent),
    data: {
      codmod: "CEN",
      icon: "edit_note",
    },
  },
   {
    path: "config_almacenamiento-comprobantes",
    loadComponent: () =>
      import(
        "./almacenamiento-comprobantes/almacenamiento-comprobantes.component"
      ).then((m) => m.AlmacenamientoComprobantesComponent),
    data: {
      codmod: "CEN",
      icon: "folder_open",
    },
  },
  {
    path: "config_mail_template_provia",
    loadComponent: () =>
      import(
        "./config-mail-template/config-mail-template.component"
      ),
    data: {
      codmod: "CEN",
      icon: "email",
    },
  },
];
